export default "__VITE_ASSET__D1SJ77q2__"